import { BROADCAST_SET_DIRECTOR_CONTROLS } from 'actions/Types';

const initialState = {
  canScreenShare: true
};

function directorControls(state = initialState, action) {
  if (action.type === `${BROADCAST_SET_DIRECTOR_CONTROLS}`) {
    const {
      payload: { key, value }
    } = action;
    return { ...state, [key]: value };
  }
  return state;
}

export default directorControls;
